import { useState, useEffect } from "react";
import useLocalStorage from "./useLocalStorage";
import { getFileName } from "../utils/locale";

// Hook
const useLanguage = () => {
  const [localStorageVal, setValue] = useLocalStorage("language");
  const [language, setLanguage] = useState(() => {
    if (localStorageVal) {
      return localStorageVal;
    }
    const browserLanguage =
      window.navigator.userLanguage || window.navigator.language;
    const fileName = getFileName(browserLanguage);
    setValue(fileName);
    return fileName;
  });

  useEffect(() => {
    setValue(language);
  }, [language, setValue]);

  return [language, setLanguage];
};

export default useLanguage;
